import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
    OrderItemDeadEndSource,
    isOrderItemDeadEnd,
} from 'entities/Order/lib/isOrderItemDeadEnd/isOrderItemDeadEnd';
import {
    getCanEditOwnSelectedOrder,
    getCanEditSelectedOrder,
} from 'entities/Order/model/selectors/ordersPermissions';
import { getSelectedOrderIsPreSubmission } from 'entities/Order/model/selectors/ordersSelectors';
import { getUserCanAddOrderItem } from 'entities/User/model/selectors/userPermissionsSeletors';
import { getPropertyVendorsMap } from 'entities/Vendors/model/selectors/vendorsSelectors';
import { useOrderAddItemsCatalogNavigation } from 'features/AddItemsToOrder/lib/useOrderAddItemsCatalogNavigation';

export const useOrderItemFindReplacement = (
    item: OrderItemDeadEndSource | null | undefined,
) => {
    const isPreSubmission = useSelector(getSelectedOrderIsPreSubmission);
    const vendorsMap = useSelector(getPropertyVendorsMap);
    const canAddOrderItem = useSelector(getUserCanAddOrderItem);
    const canEditSelectedOrder = useSelector(getCanEditSelectedOrder);
    const canEditOwnSelectedOrder = useSelector(getCanEditOwnSelectedOrder);
    const navigateToOrderPropertyCatalog = useOrderAddItemsCatalogNavigation();

    const canAddItems =
        (canEditSelectedOrder && canAddOrderItem) || canEditOwnSelectedOrder;

    const showFindReplacement = Boolean(
        item &&
            canAddItems &&
            isOrderItemDeadEnd(item, vendorsMap, isPreSubmission),
    );

    const onFindReplacement = useCallback(() => {
        navigateToOrderPropertyCatalog({ clearSearch: true });
    }, [navigateToOrderPropertyCatalog]);

    return { showFindReplacement, onFindReplacement };
};
